module.exports = __webpack_public_path__ + "static/media/outboundSwap.75b0afe0.svg";